<template>
  <v-card class="pa-4">
    <v-card-title class="text-subtitle-1 font-weight-bold justify-center">
      Ingreso semanal VS promedio semanal 6 meses
    </v-card-title>

    <template v-if="loading">
      <v-skeleton-loader type="image" />
    </template>
    <div v-else-if="items.length && !loading" class="d-flex justify-center">
      <apex-chart
        class="w-75"
        :options="{
          chart: { type: 'rangeBar' },
          plotOptions: {
            bar: {
              horizontal: false,
              colors: {
                ranges: [
                  {
                    from: -1000,
                    to: 0,
                    color: '#C71616',
                  },
                  {
                    from: 1,
                    to: 1000,
                    color: '#206689',
                  },
                ],
                backgroundBarOpacity: 1,
                backgroundBarRadius: 0,
              },
            },
          },
          dataLabels: {
            enabled: true,
            offsetY: 0,
            style: {
              textAnchor: 'middle',
            },
            background: {
              enabled: true,
              foreColor: '#000000',
              padding: 4,
              borderRadius: 2,
              borderWidth: 1,
              opacity: 0.92,
            },
            formatter: function (val, opts) {
              return `${val}%`;
            },
          },
          tooltip: {
            y: {
              formatter: (val) => {
                return `<b>${val}%</b>`;
              },
            },
          },
          subtitle: {
            text: 'Variación',
            align: 'center',
            style: {
              fontSize: '12px',
              color: '#206689',
            },
          },
        }"
        :series="items"
      />
    </div>
  </v-card>
</template>
<script>
  import ApexChart from 'vue-apexcharts';
  import numbersFormats from '@/mixins/numbersFormats';

  export default {
    name: 'WeeklyEarningsGraph',
    components: { ApexChart },
    mixins: [numbersFormats],
    props: {
      data: {
        type: Object,
        required: true,
      },
      loading: Boolean,
    },

    data() {
      return {
        items: [],
        chartOptions: {
          chart: {
            type: 'rangeBar',
            height: 350,
          },
          plotOptions: {
            bar: {
              horizontal: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
        },
      };
    },

    watch: {
      data: {
        handler(data) {
          this.initSeries(data);
        },
        immediate: true,
      },
    },

    methods: {
      initSeries(newData) {
        if (!newData?.rows?.length) return;
        const periods = [...newData.weeks];
        const rows = [...newData.rows];
        const lastItem = rows[rows.length - 1];

        const avg = Number(lastItem.average);

        const data = periods.map((item) => {
          const current = Number(lastItem.values[item]);
          const variation = ((current - avg) / avg) * 100;
          const formatted = this.formatFloat(
            isNaN(variation) ? 0 : variation,
            0
          );

          return {
            x: [`Semana ${item.slice(-2)}`, `${formatted}%`],
            y: [0, formatted],
          };
        });
        this.items = [
          {
            name: 'Comisiones',
            data,
          },
        ];
      },
    },
  };
</script>
